import React from 'react';
import useResourceLoader from '../util/useResourceLoader';
import UWEEntityApi from '../api/UWEEntityApi';
import Loader from '../components/Loader';
import { Trans } from '@lingui/react/macro';
import Icon from 'src/components/Icon';

const PROGRESS_CLASSES = {
  Unvisited: 'next_state',
  Current: 'current_state',
  Complete: 'complete_state',
};

function UWEEntityProgress({ entity, def, wfAccessToken }) {
  const { fromParent } = def;
  const [progressSteps, loadingSteps] = useResourceLoader(
    () => UWEEntityApi.getUWEEntityProgressSteps({ entityId: entity.id, fromParent, wfAccessToken }),
    [entity],
    []
  );

  return loadingSteps ? (
    <Loader fullscreen>
      <Trans>Loading Steps...</Trans>
    </Loader>
  ) : (
    <div className="progress-stepper">
      {progressSteps.map((step, idx) => (
        <ProgressStep key={idx} step={step} isLast={idx === progressSteps.length - 1} />
      ))}
    </div>
  );
}

function ProgressStep({ step: { name, status, isFinalStep }, isLast }) {
  const isComplete = status === 'Complete';
  const isCurrent = status === 'Current';

  return (
    <div className={`progress-step ${PROGRESS_CLASSES[status] || ''} ${isFinalStep ? 'is-last-state' : ''}`}>
      <div className="progress-step-indicator">
        <div className="progress-step-dot">
          {isComplete && <Icon icon="Check" />}
          {isCurrent && <Icon icon="Circle" />}
        </div>
        {!isLast && <div className="progress-step-line" />}
      </div>
      <div className="progress-step-label">{name}</div>
    </div>
  );
}

export default UWEEntityProgress;
